const InputWrapper = ({ id, type, setErrMessage, value, setRed, setGreen, setBlue, colorName, ...restOfProps }) => {

    const handleChange = (e)=> {
        let { value, id } = e.target;
        if(!Number.isInteger(Number(value)) || (value > 255)){
            return setErrMessage(true)
        }else{
            setErrMessage(false);
        }
        (id === "redColor") && setRed(value);
        (id === "greenColor") && setGreen(value);
        (id === "blueColor") && setBlue(value);
      }

    return (
        <div>
            <label>{colorName}</label>
            <div>
            <input {...restOfProps} onChange={handleChange} id={id} type={type} value={value} />
            </div>
        </div>
        
    );
}
export default InputWrapper;